import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });

    setTimeout(() => {
      this.#filterByInitialVariant();
    }, 500);
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  #detectColorOption = (variant, container) => {
    const altTexts = new Set();
    container.querySelectorAll('ul.media-gallery__grid li img').forEach((img) => {
      const alt = img.getAttribute('alt')?.trim().toLowerCase();
      if (alt) altTexts.add(alt);
    });

    for (const opt of ['option1', 'option2', 'option3']) {
      const val = variant[opt];
      if (val && altTexts.has(val.trim().toLowerCase())) {
        return val;
      }
    }
    return null;
  };

  #filterItems = (container, colorOption) => {
    const items = container.querySelectorAll('ul.media-gallery__grid li');
    const visibleIndexes = [];

    items.forEach((li, i) => {
      const img = li.querySelector('img');
      const alt = img?.getAttribute('alt')?.trim().toLowerCase();
      const color = colorOption.trim().toLowerCase();

      if (alt && alt !== color) {
        li.style.display = 'none';
        li.setAttribute('hidden', '');
      } else {
        li.style.display = '';
        li.removeAttribute('hidden');
        visibleIndexes.push(i);
      }
    });

    // Ocultar slideshow-slides en mobile
    const slides = container.querySelectorAll('slideshow-slide');
    slides.forEach((slide) => {
      const img = slide.querySelector('img');
      const alt = img?.getAttribute('alt')?.trim().toLowerCase();
      const color = colorOption.trim().toLowerCase();

      if (alt && alt !== color) {
        slide.setAttribute('hidden', '');
        slide.style.cssText = 'display:none !important; width:0 !important; flex:none !important; overflow:hidden !important; padding:0 !important; margin:0 !important;';
      } else {
        slide.removeAttribute('hidden');
        slide.style.cssText = '';
      }
    });

    // Ocultar dots del slideshow
    const dotsContainer = container.querySelector('.slideshow-controls__dots');
    if (dotsContainer) {
      Array.from(dotsContainer.children).forEach((dot, i) => {
        dot.style.display = visibleIndexes.includes(i) ? '' : 'none';
      });
    }
  };

  #filterByInitialVariant = () => {
    try {
      const scripts = document.querySelectorAll('script[type="application/json"]');
      let variant = null;

      scripts.forEach((s) => {
        if (!s.id && s.textContent.includes('option1')) {
          try {
            variant = JSON.parse(s.textContent);
          } catch (e) {}
        }
      });

      if (!variant) return;

      const colorOption = this.#detectColorOption(variant, this);
      if (!colorOption) return;

      this.#filterItems(this, colorOption);
    } catch (e) {
      console.error('Error filtering initial variant:', e);
    }
  };

  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;
    if (!source) return;

    const newMediaGallery = source.querySelector('media-gallery');
    if (!newMediaGallery) return;

    const variant = event.detail.resource;
    if (variant) {
      const colorOption = this.#detectColorOption(variant, newMediaGallery);
      if (colorOption) {
        this.#filterItems(newMediaGallery, colorOption);
      }
    }

    this.replaceWith(newMediaGallery);
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}